/**
 * The per-user settings store, which several unrelated hooks read and write. Its
 * id is spelled once here because the sharing below is what the id buys: a writer
 * that spelled it differently would silently get a cache entry and a write queue
 * of its own, and nothing would fail to say so.
 */
const USER_SETTINGS = "user-settings";

/**
 * One cache entry for the whole store, shared by every consumer of it: the keys
 * are disjoint but the fetch is not, and a write under one consumer has to
 * refresh the rest.
 */
export const USER_SETTINGS_QUERY_KEY = [USER_SETTINGS];

/**
 * One mutation scope for every writer, so two writes queue rather than race: the
 * store has no upsert, each write re-reads the live rows to pick create over
 * update, and interleaved reads would both see the state before either landed.
 */
export const USER_SETTINGS_MUTATION_SCOPE = { id: USER_SETTINGS };
